"use client";

import { useEffect, useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useRouter } from 'next/navigation';
import { useCheckout } from '../../context/CheckoutContext';

export default function CartIcon() {
  const { cartItems } = useCheckout();
  const router = useRouter();
  const [isClient, setIsClient] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  // Handle hydration mismatch by only showing count on client
  useEffect(() => {
    setIsClient(true);
  }, []);
  
  // Animate the cart icon when items are added
  useEffect(() => {
    if (cartItems.length > 0 && isClient) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 500);
      return () => clearTimeout(timer);
    }
  }, [cartItems.length, isClient]);
  
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  
  const handleClick = () => {
    router.push('/checkout');
  };
  
  return (
    <div 
      className="relative cursor-pointer" 
      onClick={handleClick}
    >
      <FaShoppingCart 
        className={`text-xl ${isAnimating ? 'animate-bounce text-primary' : ''}`} 
      />
      
      {isClient && totalItems > 0 && (
        <div className="absolute -top-2 -right-2 bg-primary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
          {totalItems}
        </div>
      )}
    </div>
  );
} 